import React, { PropTypes } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayFooter, InlineOverlayBody, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { Checkmark } from '@bibliocommons/base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';

import MessagingContainer from '../../../../../../containers/shared/Messaging/MessagingContainer';
import DigitalFormats from '../../digital-formats';
import BibBrief from '@bibliocommons/shared-bib-brief';

export class DigitalCheckoutWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      duration: null,
      format: null
    };
    this.bindAll('handleFormatSelect', 'handleCheckout', 'handleDurationSelect');
  }

  handleFormatSelect(format) {
    this.setState({ format });
  }

  handleDurationSelect(duration) {
    this.setState({ duration });
  }

  handleCheckout(e) {
    if (e) {
      e.preventDefault();
    }

    const { format, duration } = this.state;
    const { accountId, bib, holdId, messagingId, workflowId } = this.props;
    this.props.digitalCheckout({
      accountId,
      messagingId,
      metadataId: bib.get('id'),
      workflowId,
      title: bib.get('title'),
      format,
      duration,
      holdId
    });
  }

  renderQuickstartLink() {
    const { showQuickStartLink, quickStartUrl } = this.props;

    if (showQuickStartLink) {
      return <FormattedHTMLMessage id="digital_download_quickstart_link" values={{ quickStartUrl }} />;
    }

    return null;
  }

  render() {
    const { handleClose, bib, isLoading, formats, provider, requireFormats = false } = this.props;
    return (
      <InlineOverlay handleClose={handleClose}>
        <form action="/" onSubmit={this.handleCheckout} role="form" method="post">
          <InlineOverlayHeader>
            <FormattedMessage id="check_out_now" />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            <MessagingContainer id={bib.get('id')}>
              {
                messageOptions => <GenericForm {...messageOptions} />
              }
            </MessagingContainer>
            <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />
            <DigitalFormats
              formats={formats}
              provider={provider}
              selectable={requireFormats}
              isAvailable
              metadataId={bib.get('id')}
              onSelectFormat={this.handleFormatSelect}
              handleDurationSelect={this.handleDurationSelect}
              fetchDigitalFormats={this.props.fetchDigitalFormats} />
            {this.renderQuickstartLink()}
          </InlineOverlayBody>
          <InlineOverlayFooter>
            <PrimaryButton className="pull-right" isLoading={isLoading} type="submit">
              <Checkmark color="#FFF" /> <FormattedMessage id="check_out_now" />
            </PrimaryButton>
            <InlineOverlayCloseButton className="btn btn-link pull-right">
              <FormattedMessage id="button_nevermind_close" />
            </InlineOverlayCloseButton>
          </InlineOverlayFooter>
        </form>
      </InlineOverlay>
    );
  }
}

DigitalCheckoutWorkflowView.propTypes = {
  workflowId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  bib: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  isLoading: PropTypes.bool,
  formats: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    hasDownloadLink: PropTypes.bool
  })).isRequired,
  provider: PropTypes.string.isRequired,
  requireFormats: PropTypes.bool,
  digitalCheckout: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  fetchDigitalFormats: PropTypes.func.isRequired,
  holdId: PropTypes.string,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  borrowingActions: PropTypes.objectOf(PropTypes.func)
};

DigitalCheckoutWorkflowView.displayName = 'DigitalCheckoutWorkflowView';

export default DigitalCheckoutWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-checkout-workflow-view/components/DigitalCheckoutWorkflowView.component.jsx